import React from "react";
import {
  Autocomplete,
  TextField,
  Paper,
  MenuItem,
  IconButton,
  Tooltip,
  Box,
  Typography,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClearIcon from "@mui/icons-material/Clear";

// Custom Paper component to style the dropdown
const CustomPaper = (props) => {
  return (
    <Paper
      {...props}
      style={{
        fontSize: "40px",
        maxHeight: "none", // Remove any max height
        overflow: "visible", // Ensure overflow is visible
      }}
    />
  );
};

// Custom Dropdown Icon
const CustomDropdownIcon = (props) => (
  <IconButton {...props} style={{ padding: 0 }}>
    {" "}
    {/* Remove padding */}
    <ArrowDropDownIcon style={{ fontSize: "16px" }} />{" "}
    {/* Customize icon size */}
  </IconButton>
);

// Custom Clear Icon
const CustomClearIcon = (props) => (
  <IconButton
    {...props}
    style={{ marginRight: "-10px", padding: 0 }}
  >
    {" "}
    {/* Remove padding */}
    <ClearIcon style={{ fontSize: "16px" }} /> {/* Customize icon size */}
  </IconButton>
);

export const SearchAutoComplete = ({
  TextFieldProps,
  options,
  onChange,
  className,
  name,
  value,
}) => {
  const newValue =
    value && value.label && value.value
      ? value
      : value
        ? { value: value.imo, label: `${value.name_org} (${value.imo})` }
        : null;

  // Custom filter function to limit results to 7
  const filterOptions = (options, { inputValue }) => {
    return options.filter((option) =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    ).slice(0, 7);
  };

  return (
    <>
      <Tooltip
      title={newValue ? `${newValue.label}` : ""}
      arrow
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, -10], // Adjust the offset to move the tooltip up
            },
          },
        ],
      }}
    >
        <Autocomplete
        options={options}
        getOptionLabel={(option) => option.label}
        onChange={onChange}
        value={newValue}
        filterOptions={filterOptions}
        PaperComponent={CustomPaper} // Use custom Paper component for dropdown
        renderInput={(params) => (
          <TextField
            placeholder="Search..."
            {...params}
            name={name}
            sx={{
              '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#757575',
                  }
                },
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {/* {params.InputProps.endAdornment} */}
                  {newValue ? (
                    <CustomClearIcon onClick={() => onChange(null)} />
                  ) : null}{" "}
                  {/* Custom clear icon */}
                </>
              ),
            }}
          />
        )}
        className={className}
        style={{
          padding: "0px",
          width: "78%", // Full width of the parent
        }}
        components={{
          Popper: CustomPaper,
          ClearIndicator: CustomClearIcon, // Custom clear indicator
        }}
        disableClearable
        noOptionsText={
            <Box sx={{ padding: "2px", fontSize: "10px" }}>
              <Typography variant="body2" color="textSecondary">
                No matching vessel found
              </Typography>
            </Box>
          } // Custom "No options" message
        renderOption={(props, option) => (
          <MenuItem {...props} style={{ fontSize: "10px" }}>
            {option.label}
          </MenuItem>
        )}
        
      />
      </Tooltip>
    </>
  );
};
